<template>
  <div
      :class="{'HAS-NEW-NOTIFICATIONS': hasNewNotifications }"
      class="NOTIFICATION-LINK"
      selenium="header-notification-link">
    <vk-icon name="bell" class="h4"/>
  </div>
</template>

<script>
export default {
  name: 'header-notifications-link',
  props: {
    hasNewNotifications: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@homeservices/design-kit/tools";

.NOTIFICATION-LINK {
  position: relative;

  &:focus {
    outline: none;
    background-color: $color-gray90;
  }
}

.HAS-NEW-NOTIFICATIONS {
  &:before {
    content: '';
    background-color: $color-depot;
    @include circle(10px);
    position: absolute;
    bottom: 50%;
    left: 50%;

    @include tablet {
      @include circle(15px);
    }
  }
}
</style>
